import React from "react";
import { Dropdown, DropdownProps } from "../../../../common/components/dropdown/Dropdown";
import useFormComponentState from "../../../../common/forms/useFormComponentState";
import useRoles from "../../../../common/roles/useRoles";
import { CriterionLabel } from "../common/CriterionLabel";
import { SearchCriterion } from "../common/SearchCriterion";
import { getDropdownItems } from "./choices";
import { visibilitySelectorType } from "../../../../common/types/common";
import { dropdownItemsType, requiredRolesType } from "../../../../common/types/search/search";

interface DropdownCriterionProps extends DropdownProps {
	criterionKey: string;
	label?: string;
	quickSearch?: boolean;
	requiredRoles?: requiredRolesType;
	choices: dropdownItemsType;
	prefix?: string;
	visibilitySelector?: visibilitySelectorType;
}

export const DROPDOWN_CRITERION_INITIAL_STATE = "";

export function DropdownCriterion({
	choices,
	criterionKey,
	label,
	prefix,
	quickSearch = false,
	requiredRoles,
	visibilitySelector,
	...props
}: DropdownCriterionProps) {
	const { currentInput, onInputChange } = useFormComponentState(
		criterionKey,
		DROPDOWN_CRITERION_INITIAL_STATE,
	);
	const { roles } = useRoles();
	const dropdownToggle = currentInput
		? choices.find((item) => item.key === currentInput).value
		: "Any";

	const handleDropdownItemClick = (id, name) => {
		const key = choices.find((item) => item.value === name).key;
		onInputChange(key);
	};

	return (
		<SearchCriterion
			label={label}
			prefix={prefix}
			quickSearch={quickSearch}
			requiredRoles={requiredRoles}
			visibilitySelector={visibilitySelector}
		>
			<div className="criterion dropdown single-choice-dropdown">
				{label && <CriterionLabel label={label} prefix={prefix} />}

				<Dropdown
					dropdownKey={criterionKey}
					dropdownItems={getDropdownItems(choices, roles)}
					dropdownToggle={dropdownToggle}
					label={label}
					onDropdownItemClick={handleDropdownItemClick}
					preselected={!!currentInput}
					quickSearch={quickSearch}
					{...props}
				/>
			</div>
		</SearchCriterion>
	);
}
